// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2GhsV","list":"PatternAutocomplete_list__2YTOq"};